/**
 * The 'enableTest' field of an Action definitions may be set to one of these, or to an array of them for multiple tests.
 * @module core/enablers
 */

import {getViewCollection, getViewModel} from './utils';
import {UserSource} from '@netx/core-user-next/schema/user';
import {isMobile as checkIsMobile} from './underscore-netx';
import {mediaServicesAvailable} from '@netx/core-share-media-service/enablers';
import {assetProjectEnabled} from '@netx/core-asset-project/enablers';
import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {userProfile} from '@netx/core-user/collections/singletons/userProfile';

/**
 * Clips cannot be emailed currently
 * @function
 * @returns {boolean}
 */
export const canEmail = (v) => {
	if (v.data && v.data.assetSet) {
		return v.data.assetSet.get('canEmail') !== false;
	}
	return true;
};

/**
 * Can user logout
 * @function
 * @return {boolean}
 */
export const canLogout = (v) => {
	const userSource = userProfile.get('userSource');
	// If user source is INTERNAL or SAML
	return userSource === UserSource.INTERNAL || userSource === UserSource.SAML;
};

// TODO: We should not reference Netx.[module] (other than user) for enable tests
// DAM-11555 - currently used only for video publishing
/**
 * @function
 * @returns {boolean}
 */
export const mediaServicesEnabled = (v) => {
	if (mediaServicesAvailable()) {
		var mediaServices = Netx.share.mediaServices,
			brightCove = mediaServices.find({name: 'Brightcove'}),
			youTube = mediaServices.find({name: 'YouTube'});

		return (
			(youTube && youTube.get('authenticated')) ||
			(brightCove && brightCove.get('authenticated'))
		);
	}
	return false;
};

// collection has at least one model
/**
 * @function
 * @returns {boolean}
 */
export const collectionNotEmpty = (v) => {
	const collection = getViewCollection(v);
	if (!collection) return false;

	// Sometimes we update the pager before we get models in a collection
	const pager = collection.pager;
	if (!pager) return collection.length > 0;

	return pager.get('itemTotal') > 0;
};

/**
 * @function
 * @returns {boolean}
 */
export const canUseGridEditor = (v) => {
	return true;
};

/**
 * @function
 * @returns {boolean}
 */
export const allowsDelete = (v) => {
	if (v.model && _.isFunction(v.model.allows)) {
		return v.model.allows('delete');
	} else if (v.collection && _.isFunction(v.collection.allows)) {
		return v.collectionl.allows('delete');
	}
	return false;
};

/**
 * @function
 * @returns {boolean}
 */
export const isMobile = () => {
	return checkIsMobile(false);
};

/**
 * @function
 * @returns {boolean}
 */
export const notMobile = () => {
	return !isMobile();
};

/**
 * @function
 * @returns {boolean}
 */
export const readOnly = (v) => {
	const model = getViewModel(v);
	return !model.allows('write');
};

/**
 * Asset review enabled
 * @function
 * @returns {boolean}
 */
export const reviewEnabled = (v) => {
	// DAM-14088
	if (checkIsMobile()) return false;

	return assetProjectEnabled();
};
